import React, { useCallback, useEffect, useState } from 'react'
import Popup from 'reactjs-popup'

type DropdownMenuProps = {
	arrow?: boolean
	children: React.ReactNode
	contentStyle?: object
	onClose?: () => void
	overlayStyle?: object
	trigger: (isOpen: boolean) => JSX.Element
}

export const DropdownMenu = ({
	trigger,
	onClose,
	contentStyle,
	overlayStyle,
	arrow,
	children,
}: DropdownMenuProps) => {
	const [opened, setOpened] = useState(false)

	const handleClose = useCallback(() => {
		setOpened(false)
		onClose?.()
	}, [onClose])

	useEffect(() => {
		opened && document.addEventListener('click', handleClose, false)

		return () => document.removeEventListener('click', handleClose)
	}, [opened, handleClose])

	const handleDropdownClick = (e: React.MouseEvent) => {
		e.nativeEvent.stopImmediatePropagation()
	}

	return (
		<Popup
			trigger={trigger}
			open={opened}
			onOpen={() => setOpened(true)}
			position="bottom right"
			contentStyle={contentStyle}
			overlayStyle={overlayStyle}
			arrow={arrow}
			closeOnDocumentClick={false}
			data-testid="dropdown-menu"
		>
			<div onClick={handleDropdownClick} data-testid="dropdown-menu-content">{children}</div>
		</Popup>
	)
}
